import { ReactElement } from 'react';

import { CartProps } from '~/types/cart';
import { currencyWithCents } from '~/lib/format';

export default function Credits({
  cart,
}: Readonly<{ cart?: CartProps }>): ReactElement {
  if (!(cart?.use_credit && cart.credit > 0)) return <></>;

  return (
    <div>
      <div className="flex">
        <div className="grow">Credits applied:</div>
        <div className="font-medium italic text-grace">
          -{currencyWithCents(cart.credit)}
        </div>
      </div>
    </div>
  );
}
